import { dateTimeLabel } from '../lib/format.js';

/**
 * «Stand 10:42 · Aktualisieren» – zeigt, wie alt die angezeigten Exxas-Daten sind, und holt sie nur auf Tipp neu
 * (Exxas-Aufrufe sparen: kein automatisches Nachladen).
 * @param {{ abfragen: import('@tanstack/react-query').UseQueryResult[] }} props
 */
export function Stand({ abfragen }) {
  const qs = abfragen.filter(Boolean);
  const zeiten = qs.map((q) => q.dataUpdatedAt).filter(Boolean);
  const stand = zeiten.length ? Math.min(...zeiten) : 0;
  const laedt = qs.some((q) => q.isFetching);
  const fehler = qs.find((q) => q.isError && q.data !== undefined);
  return (
    <div className="row stand" style={{ gap: 6, flexWrap: 'wrap' }}>
      <span className="sub" style={{ fontSize: 12 }}>
        {laedt ? 'Lädt aus Exxas …' : stand ? `Stand ${dateTimeLabel(new Date(stand).toISOString())}` : 'Noch nicht geladen'}
        {fehler && !laedt ? ' · Aktualisieren fehlgeschlagen' : ''}
      </span>
      <button className="linkbtn" style={{ fontSize: 12, padding: '12px 6px', margin: '-12px -6px' }} onClick={() => qs.forEach((q) => q.refetch())} disabled={laedt}>
        Aktualisieren
      </button>
    </div>
  );
}
